module.exports = __webpack_public_path__ + "media/images/categories/apartment-f62d1ff73e4336629028a908ce7bf9f3.png";